import React, { useState } from "react";

import { Icon, LegacyStack, Link, Spinner } from "@shopify/polaris";
import { CircleTickMajor } from "@shopify/polaris-icons";

import { GettingStartedStoreAccess } from "../../../libs/store";
import themeGateway from "@vendor-app/gateways/ValidateThemeFile";
import { useToast } from "@vendor-app/app/_sharedComponents/Toast/ToastProvider";
import { useGetThemeName } from "../../../libs/hooks/useGetThemeName";

export function VerifyImplementationButton() {
  const { setDisplayVerifyImplementationText, update } = GettingStartedStoreAccess.useActions();
  const setup = GettingStartedStoreAccess.useSetup();
  const chosenThemeId = GettingStartedStoreAccess.useChosenThemeId();
  const [isLoading, setIsLoading] = useState(false);
  const { addToast } = useToast();

  const getThemeName = useGetThemeName();

  const clickHandler = async () => {
    setIsLoading(true);

    try {
      const themeName = getThemeName(chosenThemeId);
      addToast(`Checking product.json on ${themeName}`);

      const verificationResponse = await themeGateway.verifyAppBlock(chosenThemeId, "templates/product.json");

      update(
        [
          {
            path: "snippetsThemeId",
            val: chosenThemeId,
          },
          {
            path: "onSiteSetup.smartrrWidget.verified",
            val: verificationResponse,
          },
          {
            path: "onSiteSetup.smartrrWidget.completed",
            val: verificationResponse,
          },
        ],
        "subscriptionBlock"
      );

      if (verificationResponse) {
        setDisplayVerifyImplementationText(false);

        addToast("App block implementation verified.");
        return;
      }

      setDisplayVerifyImplementationText(true);

      addToast("App block implementation could not be verified.");
    } catch {
      addToast("An error occurred when attempting to verify the app block implementation.", true);
      setDisplayVerifyImplementationText(true);
    } finally {
      setIsLoading(false);
    }
  };

  if (!chosenThemeId) {
    return;
  }

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <LegacyStack>
      <div data-testid="app-block-verify-button">
        <Link onClick={clickHandler}>Verify block implementation</Link>
      </div>
      {setup?.onSiteSetup?.smartrrWidget?.verified ? (
        <Icon source={CircleTickMajor} color="success" />
      ) : (
        <React.Fragment />
      )}
    </LegacyStack>
  );
}
